export default __webpack_public_path__ + "static/Dont-Keep-content-simple-and-focused-98db9aea74a1c60951ba1cd6530af35d046186f70ddded814425b7de81f06654.png";